import { CardMedia, Stack } from "@mui/material";
import TitleAndContent from "./TitleAndContent";
import ReactPlayer from 'react-player'

export default function OverviewProductSection() {
    return (<Stack sx={{
        alignItems: 'center',
        justifyContent: 'space-evenly',
        height: '100vh',
        marginBottom: '10vh'
    }}>
        <TitleAndContent title={"Overview our product"} content={"Take a look at the product video demo"} />
        <ReactPlayer 
            src='https://youtu.be/QujTTkk5or0' 
            width = '75vw'
            height = '65vh'
            loop = {true}
            playing = {true}
            muted = {true}
            controls = {true}
            style = {{ borderRadius: '1rem', maxWidth: '100%'}}
        />
    </Stack>)
}